import React from "react";
import { BiSort, BiSortUp, BiSortDown, BiXCircle } from "react-icons/bi";
import { getSortState } from "../../helpers/tableSorting";

//Sortable column header with icon reflecting current ASC/DESC state, its priority
//(shown when more columns are sorted) and an icon clearing only this column's sort
export const SortableHeader = ({ label, field, ordering, onSort, onClear }) => {
  const { direction, position, total } = getSortState(ordering, field);
  const isAsc = direction === "asc";
  const isDesc = direction === "desc";
  const SortIcon = isAsc ? BiSortUp : isDesc ? BiSortDown : BiSort;

  return (
    <>
      <span>{label}</span>
      <span>
        <SortIcon
          style={{ cursor: "pointer", color: "#02385d", fontSize: "18px" }}
          title={
            isAsc ? "Řazeno vzestupně" : isDesc ? "Řazeno sestupně" : "Seřadit"
          }
          onClick={() => onSort(field)}
        />
        {direction && total > 1 && (
          <span
            style={{ color: "#02385d", fontSize: "12px", fontWeight: "bold" }}
            title={`Pořadí řazení: ${position}`}
          >
            {position}
          </span>
        )}
        {direction && (
          <BiXCircle
            style={{
              cursor: "pointer",
              color: "#02385d",
              fontSize: "18px",
              marginLeft: 4,
            }}
            title="Zrušit řazení"
            onClick={() => onClear(field)}
          />
        )}
      </span>
    </>
  );
};
